<mode-format-shortcut-menu
  [field]="field"
  [format]="format.default"
  (update)="updateDefaultFormat($event)"
  *ngIf="field.isContinuous || chartType !== 'vegasPivotTable'"
></mode-format-shortcut-menu>
<mode-format-builder-rotation
  [angle]="format.label?.rotation"
  (update)="updateRotation($event)"
  *ngIf="chartType !== 'vegasPivotTable'"
></mode-format-builder-rotation>
